import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import axiosAuth from "@/services/axiosAuth";
import { PROPERTY_BLOCK_WITHOUT_COMMUNITY } from "./apiRoutes";

interface GetProps {
  communityId: string;
  zoneId: string;
  queryParams?: Omit<UseQueryOptions, "queryKey">;
}
const getPropertyBlockByCommunityZone = async (communityId: string, zoneId: string) => await axiosAuth.get(`${PROPERTY_BLOCK_WITHOUT_COMMUNITY}/communities/${communityId}/zones/${zoneId}/blocks`);

const useGetPropertyBlockByCommunityZone = ({
  communityId,
  zoneId,
  queryParams
}: GetProps): UseQueryResult<any> => {
  return useQuery({
    queryKey: ["property-block-zone", communityId, zoneId],
    queryFn: () => getPropertyBlockByCommunityZone(communityId, zoneId),
    select: (data: any) => data.data,
    refetchOnWindowFocus: false,
    ...queryParams,
    enabled: !!communityId && !!zoneId && (queryParams?.enabled ?? true),
  });
};

export default useGetPropertyBlockByCommunityZone;
